export default __webpack_public_path__ + "static/media/githubIcon.69ffd9cd.png";